import { Controller } from '@hotwired/stimulus';

const SOCIAL_MEDIA_PLATFORMS = [
  {
    name: 'Twitch',
    fieldClassName: 'social-media-url__field--twitch',
    urlRegex: /twitch\.tv\//,
  },
  {
    name: 'Tiktok',
    fieldClassName: 'social-media-url__field--tiktok',
    urlRegex: /tiktok\.com\//,
  },
  {
    name: 'Youtube',
    fieldClassName: 'social-media-url__field--youtube',
    urlRegex: /youtube\.com\//,
  },
  {
    name: 'Link do canal ou rede social',
    fieldClassName: 'social-media-url__field--others',
    urlRegex: /.*/,
  },
];

/* eslint-disable max-len */
const FIELD_TEMPLATE = `
  <div class="social-media-url__field social-media-url__field--others">
    <div class="social-media-url__platform-icon-container">
      <div class="social-media-url__platform-icon"></div>
    </div>

    <div class="h-form__field mb-0">
      <label class="h-form__label">Link do canal ou rede social</label>
      <input type="text" class="h-form__input" data-action="input->social-media-urls#formatUrl" placeholder="https://" />
      <input type="url" name="social_media_urls[]" class="d-none" />
    </div>

    <button type="button" class="social-media-url__remove mt-3" data-action="social-media-urls#remove">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path stroke="#0F1C39" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6 6 18M6 6l12 12"/></svg>
    </button>
  </div>
`;
/* eslint-enable max-len */

const SOCIAL_MEDIA_FIELD_CLASS_NAMES = SOCIAL_MEDIA_PLATFORMS.map((socialMedia) => socialMedia.fieldClassName);

const FIELD_SELECTOR = '.social-media-url__field';

// Regex from https://uibakery.io/regex-library/url
// eslint-disable-next-line max-len
const URL_REGEX = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;

const formatUrl = (url) => {
  let formattedUrl = url.toLowerCase().trim();

  if (formattedUrl.length === 0) {
    return '';
  }

  if (!formattedUrl.match(/^https?:\/\//)) {
    formattedUrl = `https://${formattedUrl}`;
  }

  return formattedUrl;
};

export default class extends Controller {
  static targets = ['fields', 'submit'];

  static values = { urls: Array };

  connect() {
    this.makeSureAtLeastOneFieldExists();

    this.urlsValue.forEach((url) => {
      const $addedField = this.add();

      const $unformattedInput = $addedField.find('input[type="text"]');

      $unformattedInput.val(url);

      this.formatUrlForInput($unformattedInput[0]);
    });

    this.checkSubmitValidity();
  }

  makeSureAtLeastOneFieldExists() {
    if (this.urlsValue.length === 0) {
      this.urlsValue = [''];
    }
  }

  add() {
    const $addedField = $(FIELD_TEMPLATE);

    $(this.fieldsTarget).append($addedField);

    return $addedField;
  }

  remove(event) {
    const $removeButton = $(event.currentTarget);
    $removeButton.closest(FIELD_SELECTOR).remove();

    this.updateLabelCounters();
    this.checkSubmitValidity();
  }

  formatUrl(event) {
    this.formatUrlForInput(event.currentTarget);
  }

  formatUrlForInput(input) {
    const $unformattedInput = $(input);
    const $formattedInput = $unformattedInput.siblings('input[name="social_media_urls[]"]');
    const $field = $unformattedInput.closest(FIELD_SELECTOR);
    const $label = $unformattedInput.siblings('label');

    const formattedUrl = formatUrl($unformattedInput.val());
    $formattedInput.val(formattedUrl);

    const isValid = URL_REGEX.test(formattedUrl) || formattedUrl === '';

    $unformattedInput.toggleClass('is-invalid', !isValid);

    const socialMedia = SOCIAL_MEDIA_PLATFORMS.find((socialMediaItem) => formattedUrl.match(socialMediaItem.urlRegex));

    if (!$field.hasClass(socialMedia.fieldClassName)) {
      $field.removeClass(SOCIAL_MEDIA_FIELD_CLASS_NAMES.join(' '));
      $field.addClass(socialMedia.fieldClassName);

      $label.text(socialMedia.name);

      this.updateLabelCounters();
    }

    this.checkSubmitValidity();
  }

  updateLabelCounters() {
    SOCIAL_MEDIA_PLATFORMS.forEach((socialMedia) => {
      const $fields = $(this.fieldsTarget).find(`.${socialMedia.fieldClassName}`);

      $fields.each((index, field) => {
        const $label = $(field).find('label');

        $label.text(`${socialMedia.name} #${index + 1}`);
      });
    });
  }

  checkSubmitValidity() {
    const allValuesAreValid = $(this.fieldsTarget).find('.is-invalid').length === 0;

    this.submitTarget.disabled = !allValuesAreValid;
  }
}
